module.exports = __webpack_public_path__ + "static/media/clock-history 2.66a70acc.svg";